import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP } from '../constants';
import { getGallectionDeviationStreamId } from '../helpers';
import { getCurrentFolderId, getCurrentMediaSource, getSearchQuery, getMode, getCurrentSubfolderId } from '../selectors';
import { MediaPopupMode, MediaSourceType } from '../types';
function* handleInitGallectionDeviationStream() {
    const { mode , mediaSource , folderId , subfolderId , searchQuery  } = yield select((state)=>({
            mode: getMode(state),
            mediaSource: getCurrentMediaSource(state),
            folderId: getCurrentFolderId(state),
            subfolderId: getCurrentSubfolderId(state),
            searchQuery: getSearchQuery(state)
        }));
    const currentGallectionFolderId = subfolderId || folderId;
    const streamId = getGallectionDeviationStreamId(mediaSource, currentGallectionFolderId, searchQuery);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    let cacheStreams = true;
    if (searchQuery || mode === MediaPopupMode.MANAGER || mediaSource === MediaSourceType.STASH) {
        cacheStreams = false;
    }
    if (isStreamInitialized && cacheStreams) {
        return;
    }
    const streamParams = {
        mediaSource,
        folderId: currentGallectionFolderId,
        searchQuery
    };
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            groupId: MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP,
            streamParams,
            itemsPerFetch: DEVIATIONS_PER_FETCH,
            hasMore: true
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitGallectionDeviationStream;
